import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { CSVLink, CSVDownload } from "react-csv";
import { connect } from "react-redux";
import * as actions_stock from "redux/actions/stockActions";
import * as actions_option from "redux/actions/optionTradeActions";
import * as quoteActions from "redux/actions/quoteActions";
import { Translate, I18n } from "react-redux-i18n";
import ListStockSelect from 'components/ListStockSelect';
import { EntryModalStock, Row, SubRow } from './components';
import MiniLoader from "components/MiniLoader";
import { AngleRight } from 'theme/icon';

const useStyles = {
    root: {},
    content: {
        padding: 0
    },
    inner: {
        minWidth: 800
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    status: {
        // marginRight: theme.spacing(1)
    },
    actions: {
        justifyContent: 'flex-end'
    },
    toolbar: {
        display: 'flex',
        alignItems: 'baseline'
    },
    button: {
        paddingInline: "10px",
        color: "gray"
    },
    label: {
        borderStyle: "groove",
        padding: "7px",
        borderRadius: "5px",
        marginInline: "5px"
    }

};

const stylesLocal = {
    subcell: {
        padding: "5px"
    },
    cell: {
        padding: "8px"
    }
};

const formatQuote = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) {
        return '0.00';
    }
    return n.toFixed(2);
};

const getPriceStockBid = (stock, item) => {
    const quote = (stock[item.symbol] && stock[item.symbol].o)
        || item.bid
        || item.price
        || 0;
    return formatQuote(quote);
};

const getPriceStockAsk = (stock, item) => {
    const quote = (stock[item.symbol] && stock[item.symbol].c)
        || item.ask
        || item.price
        || 0;
    return formatQuote(quote);
};


const Trade = props => {
    const { className, ...rest } = props;

    const [list, setList] = useState(props.list);
    //const [cap, setCap] = useState(0.0);
    const headers = [
        { label: "Opn Int", key: "opn_int" },
        { label: "Delta", key: "delta" },
        { label: "Volm", key: "volm" },
        { label: "Bid", key: "bid" },
        { label: "Ask", key: "ask" },
        { label: "Strike", key: "strike" },
        { label: "Bid", key: "bid" },
        { label: "Ask", key: "ask" },
        { label: "Volm", key: "volm" },
        { label: "Delta", key: "delta" },
        { label: "Opn Int", key: "opn_int" },
    ];

    const dataCsv = () => {
        let data = [];
        props.list.forEach(element => {
            let item = {};
            headers.forEach(ref => {
                item = {
                    ...item,
                    [ref.key]: element[ref.key]
                };
            });
            data = data.concat(item);
        });
        return data;
    }

    useEffect(() => {
        setDialogState(
            {
                isValid: false,
                values: {
                    name: "fuboTV Inc.",
                    symbol: "FUBO",
                    bid: getPriceStockBid(props.stock, { symbol: "FUBO", price: 0 }),
                    ask: getPriceStockAsk(props.stock, { symbol: "FUBO", price: 0 }),
                    id: props.user_id,
                    rows: 6
                },
                touched: {},
                errors: {}
            }
        );
        props.loadList({
            id: props.user_id,
            symbol: dialogState.values.symbol,
            rows: dialogState.values.rows
        }, props.token);
    }, []);//list

    const [dialogState, setDialogState] = useState({
        isValid: false,
        values: {
            //quantity: 1,
            //open_price: 0.01,
            //strike: 1,
            // open_at: new Date().toISOString().split('T')[0],
            // expire_at: new Date().toISOString().split('T')[0],
            //share: false,

            name: "fuboTV Inc.",
            symbol: "FUBO",
            bid: 0,
            ask: 0,
            id: props.user_id,
            rows: 6
        },
        touched: {},
        errors: {}
    });

    const onClickSelected = (item) => {
        if (!item?.symbol) {
            return;
        }
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                symbol: item.symbol,
                name: item.name || item.symbol,
                bid: getPriceStockBid(props.stock, item),
                ask: getPriceStockAsk(props.stock, item)
            },
        }));
        props.resetList();
        props.loadStockQuotes([item.symbol], props.user_id, props.token);
        props.loadList({
            id: props.user_id,
            symbol: item.symbol,
            rows: dialogState.values.rows
        }, props.token);
    };

    const handleChangeSymbol = (event) => {
        event.persist();
        if (event.target.value.trim() !== dialogState.values.symbol) {
            setDialogState(dialogState => ({
                ...dialogState,
                values: {
                    ...dialogState.values,
                    [event.target.name]: event.target.value.trim(),
                    name: ""
                },
                touched: {
                    ...dialogState.touched,
                    [event.target.name]: true
                }
            }));
            props.searchList({ id: props.user_id, search: event.target.value }, props.token);
        }
        else props.resetList();
    };

    useEffect(() => {
        const symbol = dialogState.values.symbol;
        if (!symbol || !dialogState.values.name) {
            return;
        }

        const item = { symbol, price: dialogState.values.ask };
        const bid = getPriceStockBid(props.stock, item);
        const ask = getPriceStockAsk(props.stock, item);

        if (bid === dialogState.values.bid && ask === dialogState.values.ask) {
            return;
        }

        setDialogState((prev) => ({
            ...prev,
            values: {
                ...prev.values,
                bid,
                ask,
            },
        }));
    }, [props.stock, dialogState.values.symbol, dialogState.values.name, dialogState.values.bid, dialogState.values.ask]);

    const option_row = [
        { value: '6', label: '6' },
        { value: '8', label: '8' },
        { value: '10', label: '10' },
        { value: '12', label: '12' },
        { value: 'all', label: I18n.t('all') },
    ];

    const handleChangeRows = (event) => {
        const rows = event.target.value;

        setDialogState((prev) => ({
            ...prev,
            values: {
                ...prev.values,
                rows,
            },
        }));

        if (dialogState.values.symbol) {
            props.loadList({
                id: props.user_id,
                symbol: dialogState.values.symbol,
                rows,
            }, props.token);
        }
    };
    return (
        <div className=''
            // {...rest}
            // className={clsx(useStyles.root, className)}
        >
            <div className={''} style={{ "display": "flex", "alignItems": "center", "padding": "10px" }}>
                <span style={{ "paddingInline": "10px" }}>
                    Ticker
                </span>
                <div className="symbol-search-wrap symbol-search-wrap--inline">
                    <input
                        autoFocus
                        margin="dense"
                        id="symbol"
                        name="symbol"
                        required
                        type="text"
                        onChange={handleChangeSymbol}
                        autoComplete="off"
                        value={dialogState.values.symbol && dialogState.values.symbol.toLocaleUpperCase()}
                        style={{ paddingInline: '10px' }}
                    />
                    {dialogState.values.symbol.length > 0 && !dialogState.values.name && (
                        <ListStockSelect
                            list={props.list}
                            loading={props.loading}
                            onClickSelected={onClickSelected}
                        />
                    )}
                </div>
                <EntryModalStock
                    button_name={"Bid"}
                    symbol={dialogState.values.symbol}
                    name={dialogState.values.name}
                    price={dialogState.values.bid}
                    kind={"SELL"}
                />
                <label className={''} style={{ borderStyle: "groove",
        padding: "7px",
        borderRadius: "5px",
        marginInline: "5px" }}>{dialogState.values.bid}</label>
                <label className={''} style={{ borderStyle: "groove",
        padding: "7px",
        borderRadius: "5px",
        marginInline: "5px" }}>{dialogState.values.ask}</label>
                <EntryModalStock
                    button_name={"Ask"}
                    symbol={dialogState.values.symbol}
                    name={dialogState.values.name}
                    price={dialogState.values.ask}
                    kind={"BUY"}
                />

                <input
                    autoFocus
                    margin="dense"
                    id="name"
                    name="name"
                    label=" "
                    disabled
                    type="text"
                    value={dialogState.values.name}
                    //fullWidth
                    //sx={{ m: 2, width: '100px' }}
                    variant="standard"
                    autoComplete="off"
                    style={{ "paddingInline": "10px", width: '300px' }}
                />
                <span style={{ "width": "100%" }} />
                <select
                    id="rows"
                    name="rows"
                    required
                    style={{ "width": "100px", "padding": "10px" }}
                    onChange={handleChangeRows}
                    value={String(dialogState.values.rows)}
                >
                    {option_row.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className='divider' />
            <div  className={''}>

                        <table className="table table-hover table-fixed portfolio-sticky-table">
                            <thead>
                                <tr>
                                    <th align="right"> Opn Int</th>
                                    <th align="right">Delta</th>
                                    <th align="right">Volm</th>
                                    <th align="right">Bid</th>
                                    <th align="right">Ask</th>
                                    <th sortDirection="desc" align="center" >Strike</th>
                                    <th align="right">Bid</th>
                                    <th align="right">Ask</th>
                                    <th align="right">Volm</th>
                                    <th align="right">Delta</th>
                                    <th align="right">Opn Int</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    props.listOption.map((item, index) => (
                                        <Row
                                            key={index}
                                            item={item}
                                            price={
                                                (Number(dialogState.values.ask) + Number(dialogState.values.bid)) / 2
                                            }
                                            name={dialogState.values.name}
                                            symbol={dialogState.values.symbol}
                                        />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
            <div className='divider' />
            {
                props.loadingOption && (
                    <div className='card-actions' style={{ "justifyContent": "center", }}>
                        <MiniLoader />
                    </div>
                )
            }
        </div>
    );
};

Trade.propTypes = {
    className: PropTypes.string
};

function mapStateToProps(reducer) {
    // console.log(reducer);
    return {

        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.stock.list,
        error: reducer.stock.error,
        loading: reducer.stock.loading,

        stock: reducer.event.stock,

        listOption: reducer.optionTrade.list,
        errorOption: reducer.optionTrade.error,
        loadingOption: reducer.optionTrade.loading,
    };
}
const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions_option.loadList({ params, token })),
    /////////
    searchList: (params, token) =>
        dispatch(actions_stock.searchList({ params, token })),
    resetList: () =>
        dispatch(actions_stock.resetList({})),
    loadStockQuotes: (symbols, user_id, token) =>
        dispatch(quoteActions.loadStockQuotes({ symbols, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Trade);
/**
 *   

                                action={

                }

 */
